<form>
  <div class="row">
    <div class="col-md-12 col-xl-12">
      <div class="table-responsive our-table">
        <table class="table table-striped text-nowrap mb-0 title-case-table">
          <thead class="border-top">
            <tr>
              <th>Data De Cadastro</th>
              <th>Cnpj</th>
              <th>Razão Social</th>
              <th>Email</th>
              <th>GGR</th>
              <th>Modalidade Lotérica</th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-bottom" *ngFor="let row of rows">
              <td>
                {{
                  row?.insertDate
                    ? (row?.insertDate | date: "dd/MM/yyyy HH:mm:ss" : "GMT")
                    : "-"
                }}
              </td>
              <td>
                {{
                  row?.company?.cnpj
                    ? (row?.company?.cnpj | mask: "CPF_CNPJ")
                    : "-"
                }}
              </td>
              <td>{{ row?.company?.razaoSocial || "-" }}</td>
              <td>{{ row?.company?.email || "-" }}</td>
              <td>{{ row?.percentGGR ?? 0 | number: "1.2-2" }}%</td>
              <td>{{ productLabel(row?.productId) }}</td>
            </tr>

            <tr *ngIf="rows.length == 0">
              <td colspan="6">{{ "common.noData" | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</form>
